import { Provider } from '..'

export const getProviders = (): Provider[] => {
    return [
        {
            providerId: 1,
            providerName: 'American Water',
        },
        {
            providerId: 2,
            providerName: 'Aqua America',
        },
        {
            providerId: 3,
            providerName: 'Atmos Energy',
        },
        {
            providerId: 4,
            providerName: 'Con Edison',
        },
        {
            providerId: 5,
            providerName: 'Duke Energy',
        },
        {
            providerId: 6,
            providerName: 'National Grid',
        },
        {
            providerId: 7,
            providerName: 'Sempra Energy',
        },
        {
            providerId: 8,
            providerName: 'Southern Company',
        },
    ]
}
